if (!window.acNavigationReady) {
  window.acNavigationReady = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ac-mega[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.ac-mega[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
}

if (!window.acMegaHoverReady) {window.acMegaHoverReady=true;
 const desktop=()=>matchMedia('(min-width:990px) and (hover:hover)').matches;
 document.addEventListener('pointerover',e=>{const menu=e.target.closest('.ac-navigation--desktop .ac-mega');if(menu&&desktop())menu.open=true;});
 document.addEventListener('pointerout',e=>{const menu=e.target.closest('.ac-navigation--desktop .ac-mega');if(menu&&desktop()&&!menu.contains(e.relatedTarget))menu.open=false;});
 document.addEventListener('focusout',e=>{const menu=e.target.closest('.ac-navigation--desktop .ac-mega');if(menu&&!menu.contains(e.relatedTarget))menu.open=false;});
}
